module.exports = __webpack_public_path__ + "img/awards_chip2.7d55c4c8.png";